/**
 * The pipeline stages a company can hand candidates over from.
 *
 * `REJECTED` and `WITHDRAWN` are absent, and the backend refuses them too:
 * "from rejected onwards" would hand over nobody, forever, and a dropdown
 * that offered it would be inviting somebody to break their own integration.
 */
export const HANDOVER_STAGES = [
  { value: 'SUBMITTED', label: 'Everyone who applies' },
  { value: 'UNDER_REVIEW', label: 'Once we start reviewing them' },
  { value: 'SHORTLISTED', label: 'Once we shortlist them' },
  { value: 'INTERVIEW', label: 'Once we invite them to interview' },
  { value: 'DECISION_PENDING', label: 'Once they finish an interview round' },
  { value: 'OFFERED', label: 'Once we make them an offer' },
  { value: 'OFFER_ACCEPTED', label: 'Once they accept our offer' },
  { value: 'HIRED', label: 'Only when they join' },
];

export function stageLabel(value) {
  return HANDOVER_STAGES.find((stage) => stage.value === value)?.label ?? value;
}

const CONNECTION_TONES = {
  ACTIVE: 'success',
  DISABLED: 'neutral',
  ERROR: 'danger',
};

const CONNECTION_LABELS = {
  ACTIVE: 'Connected',
  DISABLED: 'Switched off',
  ERROR: 'Needs attention',
};

export function connectionTone(status) {
  return CONNECTION_TONES[status] ?? 'neutral';
}

export function connectionLabel(status) {
  return CONNECTION_LABELS[status] ?? status;
}

const BATCH_TONES = { COMPLETED: 'success', PARTIAL: 'warning', FAILED: 'danger' };

const BATCH_LABELS = {
  COMPLETED: 'Sent',
  // Neither a success nor a failure, and calling it either would mislead
  // whoever reads the history later.
  PARTIAL: 'Partly sent',
  FAILED: 'Failed',
};

export function batchTone(status) {
  return BATCH_TONES[status] ?? 'neutral';
}

export function batchLabel(status) {
  return BATCH_LABELS[status] ?? status;
}
